import { isSignal, Signal } from '@angular/core';

export type MaybeSignal<T> = T | Signal<T>;

export function valueOf<T>(value: MaybeSignal<T>): T {
  return isSignal(value) ? value() : value;
}
